import React from 'react'
import Footer1 from "../footer1/footer1";
import Footer2 from "../footer2/footer2";

function FindMore() {
  return (
    <>
      <div id="FeaturedProducts">
        <h1>Find More of Our Collections</h1>
        <div className="featuredProducts_container">
          <div className="product_cards">
            <img src="/images/Products/2.jpg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (45).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/71J6k7xyW9L._SX569_.jpg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (63).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Women</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (67).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Women</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (74).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img
              src="/images/Products/Sa11dd9bfa4e24bc280d8881c10e4751a2.jpg_640x640Q90.jpg_.webp"
              alt=""
            />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img
              src="/images/Products/Screenshot 2023-08-22 091858.png"
              alt=""
            />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (3).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (79).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (33).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (49).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (77).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (41).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (48) (1).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img
              src="/images/Products/Mens-Boys-3-Piece-Suit-Tan-Navy-Check-Wedding-Prom-Formal-Vintage-Tailored-Fit_grande.jpeg"
              alt=""
            />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (72).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (31).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/81Twm+rwDbL._AC_UY1100_.jpg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>

          <div className="product_cards">
            <img src="/images/Products/images (81).jpeg" alt="" />
            <h4>Red Printed T-shirts</h4>
            <span>Men</span>
            <p>$50.00</p>
          </div>
        </div>
      </div>

      <hr />

      <Footer1 />
      <Footer2 />
    </>
  );
}

export default FindMore